export const SaveIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 16 16"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.80273 0.280685C7.80273 4.28069 7.80274 8.78069 7.80274 10.6822M7.80274 10.6822L5.18738 8.5784M7.80274 10.6822L10.4697 8.5784"
				stroke="currentColor"
				strokeWidth="0.561364"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M13.9746 8.78069C14.7464 8.78069 15.372 9.40635 15.3721 10.1781V13.7563L15.3652 13.8988C15.2984 14.5564 14.7757 15.079 14.1182 15.1459L13.9746 15.1537H1.39746L1.25488 15.1459C0.597079 15.0792 0.0736611 14.5566 0.00683594 13.8988L0 13.7563V10.1811C0 9.4562 0.55088 8.85922 1.25684 8.78752L1.40039 8.78069H2.19922V9.34026H1.40039C0.936471 9.34026 0.55957 9.71716 0.55957 10.1811V13.7563C0.559787 14.2186 0.935074 14.5932 1.39746 14.5932H13.9746C14.437 14.5932 14.8123 14.2186 14.8125 13.7563V10.1781C14.8125 9.71563 14.4371 9.34026 13.9746 9.34026H13.1992V8.78069H13.9746Z" />
		</svg>
	);
};
